import React, { FormEvent, useCallback, useEffect, useState } from 'react'
import { Chart } from 'react-google-charts'
import {
    Container,
    Title,
    Period,
    Content,
    Main,
    Cards,
    Aside,
    Box,
    ContractsList,
} from './styles'
import { MdMoreVert } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import api, { operation } from '../../services/axios'
import { UnitsReceivable, ContratoProtocol, ChartData } from './interfaces'
import { cnpjCpfMask } from '../../utils/masks'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { selectedMenu } from '../../store/modules/menu/actions'
import { RiExchangeDollarLine } from 'react-icons/ri'
import Loading from '../../components/Loading'
import { get } from 'lodash'
import Dialog from '../../components/Dialog'
import ContractsModal from '../../components/ContractsModal'

import { BsPlus } from 'react-icons/bs'
import * as actions from '../../store/modules/cerc/actions'
import { toast } from 'react-hot-toast'
import dayjs from '../../libs/dayjs'
import Overview from '../../components/Overview'

const Dashboard: React.FC = () => {
    const { cnpj_cpf } = useSelector((state: StoreState) => state.auth.user)
    const dispatch = useDispatch()
    const [receivableUnits, setReceivableUnits] = useState<UnitsReceivable[]>(
        []
    )
    const [contractsSent, setContractsSent] = useState<ContratoProtocol[]>([])
    const [contractsReceived, setContractsReceived] = useState<
        ContratoProtocol[]
    >([])
    const [chartData, setChartData] = useState<ChartData[]>([])
    const [period, setPeriod] = useState(5)
    const [isLoading, setIsLoading] = useState(false)
    const [contractSelected, setContractSelected] = useState(
        {} as ContratoProtocol
    )
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isExtract, setIsExtract] = useState(true)

    const getChartData = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const responseChart = await api.get(
                    `/dashboard/chart/${cnpj_cpf}`
                )
                setChartData(responseChart.data.chartData)
                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf])

    useEffect(() => {
        getChartData()
    }, [getChartData])

    const getData = useCallback(async () => {
        operation.attempt(async (currentAttempt) => {
            try {
                setIsLoading(true)
                const { data } = await api.get(
                    `/dashboard/unidades/${cnpj_cpf}?period=${period}`
                )
                const received = await api.get(
                    `/dashboard/contracts/received/${cnpj_cpf}`
                )
                const sent = await api.get(
                    `/dashboard/contracts/sent/${cnpj_cpf}`
                )
                setReceivableUnits(data)
                setContractsReceived(received.data)
                setContractsSent(sent.data)
                setIsLoading(false)
            } catch (e: any) {
                setIsLoading(false)
                const status = get(e, 'response.status', '')
                // toast.error(erro)
                if (status === 401) {
                    if (operation.retry(e)) return
                }
            }
        })
    }, [cnpj_cpf, period])
    useEffect(() => {
        getData()
    }, [getData])

    async function handleSubmit(e: FormEvent) {
        e.preventDefault()
        dispatch(actions.cercDeleteAllURs())
        try {
            setIsLoading(true)
            await api.post('/agenda/solicitar', {
                cnpj_cpf: cnpj_cpf,
            })
            // fazer o reloading
            setIsLoading(false)
        } catch (error: any) {
            const message = get(error, 'response.data.error', '')
            toast.error(message)
            setIsLoading(false)
        }
    }

    const valorLivreTotal = receivableUnits.reduce((valor, atual) => {
        return valor + Number(atual.valorLivre)
    }, 0)

    const valorTotalUrs = receivableUnits.reduce((valor, atual) => {
        return valor + Number(atual.valorTotalUR)
    }, 0)

    const valorUtilizado = valorTotalUrs - valorLivreTotal
    const today = new Date().getDate()
    const date = dayjs()
        .set('date', today + period)
        .format('DD/MM/YYYY')

    function handleSelectContract(
        contract: ContratoProtocol,
        extract: boolean
    ) {
        setIsExtract(extract)
        setContractSelected(contract)
        setIsModalOpen(true)
    }

    const lastUpdate = dayjs(
        receivableUnits[0]?.agendas?.agenda?.createdAt
    ).format('DD/MM/YYYY - HH:mm:ss')

    return (
        <Container>
            <Title>
                <h1>Dashboard</h1>
                <p>Última atualização da agenda às {lastUpdate}</p>
            </Title>
            <div className="actions">
                <Period>
                    <li
                        className={period === 5 ? 'selected' : ''}
                        onClick={() => setPeriod(5)}
                    >
                        5 dias
                    </li>
                    <li
                        className={period === 10 ? 'selected' : ''}
                        onClick={() => setPeriod(10)}
                    >
                        10 dias
                    </li>
                    <li
                        className={period === 30 ? 'selected' : ''}
                        onClick={() => setPeriod(30)}
                    >
                        30 dias
                    </li>
                    <li
                        className={period === 60 ? 'selected' : ''}
                        onClick={() => setPeriod(60)}
                    >
                        60 dias
                    </li>
                    <li
                        className={period === 90 ? 'selected' : ''}
                        onClick={() => setPeriod(90)}
                    >
                        90 dias
                    </li>
                </Period>
                {/* <Link
                    to="/pagamento"
                    onClick={() =>
                        dispatch(
                            selectedMenu({
                                mainMenu: 'Pagamento',
                                subMenu: '',
                                currentLink: '/pagamento',
                            })
                        )
                    }
                >
                    <RiExchangeDollarLine size={22} /> Pagamento
                </Link> */}

                <div className="right-side">
                    <Link
                        to="/pagamento/criar"
                        onClick={() =>
                            dispatch(
                                selectedMenu({
                                    mainMenu: 'Pagamento',
                                    subMenu: '',
                                    currentLink: '/pagamento',
                                })
                            )
                        }
                    >
                        <button className="py-1 px-2 flex items-center gap-x-1 bg-green-600 hover:opacity-90 focus:ring-green-500 focus:ring-offset-green-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md">
                            {/* <BiLink size={22} /> */}
                            {/* <AiOutlinePlus size={20} /> */}
                            {/* <HiOutlinePlus size={22} /> */}
                            <BsPlus size={24} />
                            Criar pagamento
                        </button>
                    </Link>
                    {/* <form onSubmit={handleSubmit} id="ask-for-agenda">
                        <button
                            form="ask-for-agenda"
                            type="submit"
                            className="py-1 px-2 flex items-center gap-x-1 flex-shrink-0 bg-blue-600 hover:opacity-90 focus:ring-blue-500 focus:ring-offset-blue-200 text-white transition ease-in duration-100 text-center text-base font-normal shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-md "
                        >
                            Pedir nova agenda atualizada
                        </button>
                    </form> */}
                </div>
            </div>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <Cards>
                        <div className="card">
                            {/* <Chart
                                chartType="PieChart"
                                width="250px"
                                height="120px"
                                data={dataPie}
                                options={optionsPie}
                            /> */}
                            <div className="details">
                                <div className="header">
                                    <h3>Valor livre para movimentações</h3>
                                    <MdMoreVert />
                                </div>
                                <div className="balance">
                                    <p>A partir de {date}</p>
                                    <p>
                                        {valorLivreTotal.toLocaleString(
                                            'pt-br',
                                            {
                                                style: 'currency',
                                                currency: 'BRL',
                                            }
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            {/* <Chart
                                chartType="PieChart"
                                width="250px"
                                height="120px"
                                data={dataPie}
                                options={optionsPie}
                            /> */}
                            <div className="details">
                                <div className="header">
                                    <h3>Valor utilizado</h3>
                                    <MdMoreVert />
                                </div>
                                <div className="balance">
                                    <p>A partir de {date}</p>
                                    <p>
                                        {valorUtilizado.toLocaleString(
                                            'pt-br',
                                            {
                                                style: 'currency',
                                                currency: 'BRL',
                                            }
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Cards>
                    <Content>
                        <Main>
                            {/* <Chart
                                chartType="Bar"
                                data={data}
                                options={options}
                                className='chart'
                            /> */}
                            <Overview data={chartData} />
                        </Main>
                        <Aside>
                            {/* <Box>
                                <div className="title">
                                    <p>
                                        <Link to='/recebimentos' onClick={() => dispatch(selectedMenu({ mainMenu: 'Recebimentos', subMenu: '', currentLink: '/recebimentos' }))}>Gerenciar recorrências</Link> <span> <RiExchangeDollarLine size={22}/> </span>
                                    </p>
                                    <MdMoreVert size={22} />
                                </div>
                            </Box> */}
                            {/* <Box>
                                <div className="title">
                                    <p>
                                        <Link to='/recebimentos' onClick={() => dispatch(selectedMenu({ mainMenu: 'Recebimentos', subMenu: '', currentLink: '/recebimentos' }))}>Gerenciar links</Link> <span><BiLink size={22}/></span>
                                    </p>
                                    <MdMoreVert size={22} />
                                </div>
                            </Box> */}
                            <Box>
                                <div className="title">
                                    <p>
                                        <Link
                                            to="/extratos"
                                            onClick={() =>
                                                dispatch(
                                                    selectedMenu({
                                                        mainMenu: 'Extratos',
                                                        subMenu: '',
                                                        currentLink:
                                                            '/extratos',
                                                    })
                                                )
                                            }
                                        >
                                            Pagamentos recebidos
                                        </Link>
                                        <span className="description">
                                            {' '}
                                            - Nos últimos 15 dias
                                        </span>
                                    </p>
                                    <MdMoreVert size={22} />
                                </div>
                                <ContractsList>
                                    {contractsReceived?.map((contract) => {
                                        return (
                                            <li
                                                key={contract.id}
                                                onClick={() =>
                                                    handleSelectContract(
                                                        contract,
                                                        false
                                                    )
                                                }
                                            >
                                                {/* <SiVisa size={30} color='#2247D4' /> */}
                                                <div className="details">
                                                    <p>
                                                        {contract.nomePagador}
                                                    </p>
                                                    <p>
                                                        {cnpjCpfMask(
                                                            contract.cnpjPagador
                                                        )}
                                                    </p>
                                                </div>
                                                <p className="value">
                                                    +{' '}
                                                    {Number(
                                                        contract.saldoDevedor
                                                    ).toLocaleString('pt-br', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </p>
                                            </li>
                                        )
                                    })}
                                </ContractsList>
                            </Box>
                            <Box>
                                <div className="title">
                                    <p>
                                        <Link
                                            to="/extratos"
                                            onClick={() =>
                                                dispatch(
                                                    selectedMenu({
                                                        mainMenu: 'Extratos',
                                                        subMenu: '',
                                                        currentLink:
                                                            '/extratos',
                                                    })
                                                )
                                            }
                                        >
                                            Pagamentos enviados
                                        </Link>
                                        <span className="description">
                                            {' '}
                                            - Nos últimos 15 dias
                                        </span>
                                    </p>
                                    <MdMoreVert size={22} />
                                </div>
                                <ContractsList>
                                    {contractsSent?.map((contract) => {
                                        return (
                                            <li
                                                key={contract.id}
                                                onClick={() =>
                                                    handleSelectContract(
                                                        contract,
                                                        true
                                                    )
                                                }
                                            >
                                                {/* <SiVisa size={30} color='#2247D4' /> */}
                                                <div className="details">
                                                    <p>
                                                        {contract.nomeRecebedor}
                                                    </p>
                                                    <p>
                                                        {cnpjCpfMask(
                                                            contract.cnpjRecebedor
                                                        )}
                                                    </p>
                                                </div>
                                                <p className="value negative">
                                                    -{' '}
                                                    {Number(
                                                        contract.saldoDevedor
                                                    ).toLocaleString('pt-br', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </p>
                                            </li>
                                        )
                                    })}
                                </ContractsList>
                            </Box>
                        </Aside>
                    </Content>
                </>
            )}
            <Dialog
                isTermsOpen={isModalOpen}
                setIsTermsOpen={setIsModalOpen}
                title="Comprovante de Pagamento"
            >
                <ContractsModal
                    contract={contractSelected}
                    isExtract={isExtract}
                />
            </Dialog>
        </Container>
    )
}

export default Dashboard
